import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Session } from '../types';
import { ROUTES } from '../../lib/constants';

const useSession = () => {
  const navigate = useNavigate();
  const localStorageSession = sessionStorage.getItem('ACP-userInfo');
  const userInfo = localStorageSession
    ? (JSON.parse(localStorageSession) as Session)
    : undefined;
  const userRole = userInfo?.role;

  const isSessionExpired = useCallback((): boolean => {
    if (!userInfo) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime >= userInfo.exp;
  }, [userInfo]);

  const deleteSession = () => {
    sessionStorage.removeItem('ACP-userInfo');
    sessionStorage.removeItem('ACP-picture');
  };

  useEffect(() => {
    if (isSessionExpired()) {
      deleteSession();
      navigate(ROUTES.LOGIN);
    }
  }, [isSessionExpired, navigate]);

  return {
    userInfo,
    userRole,
    isSessionExpired,
    deleteSession,
  };
};

export default useSession;
